import { takeLatest } from 'redux-saga/effects';
import * as actionTypesNV01 from '../actions/actionTypesNO01';
import { fetchTradingPartnersSaga } from './NO01.saga';


export function* watchfetchTradingPartnersSaga() {
  yield takeLatest(actionTypesNV01.TRADING_PARTNERS_GET, fetchTradingPartnersSaga);
} 

